import React from "react";

import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import MDTypography from "materialDashboard/components/MDTypography";
import {FormSectionBox} from "../../../components/FormSection";
import {useTranslation} from "react-i18next";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import useCountriesQuery from "../../../components/inputs/CountryAutocomplete/query";


const PersonCaught = ({person, number, incidentRegistry, onDelete, onEdit, inputDisabled}) => {
    const {t} = useTranslation(['incidents']);

    const severityRegistry = incidentRegistry.data?.severity ?? [];
    const deathTypeRegistry = incidentRegistry.data?.deathType ?? [];
    const burialScaleRegistry = incidentRegistry.data?.burialScale ?? [];
    const ageRangeRegistry = incidentRegistry.data?.ageRange ?? [];
    const sexRegistry = incidentRegistry.data?.sex ?? [];
    const rescueTypeRegistry = incidentRegistry.data?.rescueType ?? [];
    const searchMethodRegistry = incidentRegistry.data?.searchMethod ?? [];
    const burialDepthRegistry = incidentRegistry.data?.burialDepth ?? [];
    const equipmentRegistry = incidentRegistry.data?.equipment ?? [];
    const jobTitleRegistry = incidentRegistry.data?.jobTitle ?? [];

    const severity = severityRegistry.find((s) => s.code === person.severity)?.description;
    const deathType = deathTypeRegistry.find((s) => s.code === person.deathType)?.description;
    const burialScale = burialScaleRegistry.find((s) => s.code === person.burialScale)?.description;
    const ageRange = ageRangeRegistry.find((s) => s.code === person.ageRange)?.description;
    const sex = sexRegistry.find((s) => s.code === person.sex)?.description;
    const rescueType = rescueTypeRegistry.find((s) => s.code === person.rescueType)?.description;
    const searchMethod = searchMethodRegistry.find((s) => s.code === person.searchMethod)?.description;
    const burialDepth = burialDepthRegistry.find((s) => s.code === person.burialDepth)?.description;
    const equipments = [
        ...(person.equipments?.map((e) => equipmentRegistry.find((s) => s.code === e.code)?.description) ?? []),
        person.equipmentOther
    ].filter(d => !!d).join(', ');
    const jobTitles = [
        ...(person.jobTitles?.map((e) => jobTitleRegistry.find((s) => s.code === e.code)?.description) ?? []),
        person.jobTitleOther
    ].filter(d => !!d).join(', ');

    const countries = useCountriesQuery();
    const nationality = countries.data?.find(country => country.code === person.nationality)?.name ?? "";

    return <FormSectionBox>
        <MDTypography fontWeight={"bold"} variant="h6" textTransform="capitalize">
            {t('incidentForm.personCaught.title')} {number}
        </MDTypography>
        <Grid container rowSpacing={2} columnSpacing={2}>

            <Grid item xs={12} md={4}>
                <MDTypography variant="body2" color="secondary">
                    <b>{severity} </b>
                    {person.severity === "3" && <>{t('incidentForm.personCaught.deathBy')} <b>{deathType}</b> { person.deathTypeOther && `(${person.deathTypeOther})` }</>}
                </MDTypography>
            </Grid>
            <Grid item xs={12} md={4}>
                <MDTypography variant="body2" color="secondary">
                    {t('incidentForm.personCaught.age')}: <b>{person.age} {!!person.ageRange && `(${ageRange})`}</b>
                </MDTypography>
            </Grid>
            <Grid item xs={12} md={4}>
                <MDTypography variant="body2" color="secondary">
                    {t('incidentForm.personCaught.sex')}: <b>{sex}</b>
                </MDTypography>
            </Grid>

            <Grid item xs={12} md={4}>
                <MDTypography variant="body2" color="secondary">
                    {t('incidentForm.personCaught.burialScale')}: <b>{burialScale}</b>
                </MDTypography>
            </Grid>
            <Grid item xs={12} md={4}>
                <MDTypography variant="body2" color="secondary">
                    <b>{nationality}</b>
                </MDTypography>
            </Grid>
            <Grid item xs={12} md={4}>
                <MDTypography variant="body2" color="secondary">
                    {!!person.local && <b>{t('incidentForm.personCaught.local')}</b>}
                </MDTypography>
            </Grid>

            <Grid item xs={12} md={4}>
                <MDTypography variant="body2" color="secondary">
                    {t('incidentForm.personCaught.equipments')}: <b>{equipments}</b>
                </MDTypography>
            </Grid>
            <Grid item xs={12} md={4}>
                <MDTypography variant="body2" color="secondary">
                    {t('incidentForm.personCaught.jobTitles')}: <b>{jobTitles}</b>
                </MDTypography>
            </Grid>
            <Grid item xs={12} md={4}>
                <MDTypography variant="body2" color="secondary">
                    {!!person.caughtWhileWorking && <b>{t('incidentForm.personCaught.caughtWhileWorking')}</b>}
                </MDTypography>
            </Grid>

            <Grid item xs={12} md={4}>
                <MDTypography variant="body2" color="secondary">
                    {t('incidentForm.personCaught.rescueType')}: <b>{rescueType}</b>
                </MDTypography>
            </Grid>
            <Grid item xs={12} md={4}>
                <MDTypography variant="body2" color="secondary">
                    {t('incidentForm.personCaught.searchMethod')}: <b>{searchMethod}</b>
                    {!!person.searchMethodOther && <b> {person.searchMethodOther}</b>}
                </MDTypography>
            </Grid>
            <Grid item xs={12} md={4}>
                <MDTypography variant="body2" color="secondary">
                    {t('incidentForm.personCaught.burialDepth')}: <b>{burialDepth}</b>
                </MDTypography>
            </Grid>

            <Grid item xs={12}>
                <Stack direction="row" spacing={2} justifyContent="end">
                    {
                        !inputDisabled && <IconButton onClick={() => onDelete(person)} color="error">
                            <Icon>delete</Icon>
                        </IconButton>
                    }
                    {
                        !inputDisabled && <IconButton onClick={() => onEdit(person)} color="info">
                            <Icon>edit</Icon>
                        </IconButton>
                    }
                </Stack>
            </Grid>
        </Grid>
    </FormSectionBox>
}


export default PersonCaught;